import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

const supabaseUrl     = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check .env file.')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession:     true,
    autoRefreshToken:   true,
    detectSessionInUrl: false, // evita re-procesar tokens en URL en cada F5
    // NO usar storageKey personalizado — causa que sesiones existentes
    // guardadas con la clave por defecto de Supabase no se encuentren
    // y el usuario aparezca como anónimo después de F5
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
})
